var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    fill: "none",
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m29.292 26.909-3.084-1.385V10.092l3.084 1.384v15.432Zm-9.25-15.433 3.083-1.384v15.432l-3.083 1.384V11.476Zm-6.167-1.384 3.083 1.384v15.432l-3.083-1.384V10.092Zm-6.167 1.384 3.084-1.384v15.432l-3.084 1.384V11.476Zm23.757-2.401L25.3 6.303c-.023-.011-.048-.013-.071-.022a1.706 1.706 0 0 0-.373-.094 1.772 1.772 0 0 0-.384 0c-.057.006-.111.02-.167.034a1.855 1.855 0 0 0-.2.06c-.022.01-.048.01-.07.022L18.5 8.789l-5.535-2.486c-.023-.011-.047-.013-.07-.022a1.702 1.702 0 0 0-.374-.094 1.774 1.774 0 0 0-.384 0c-.056.006-.11.02-.166.034a1.868 1.868 0 0 0-.2.06c-.022.01-.048.01-.07.022L5.535 9.075a1.54 1.54 0 0 0-.91 1.405v18.812a1.544 1.544 0 0 0 1.542 1.542c.214 0 .43-.045.632-.136l5.534-2.487 5.535 2.487c.023.01.048.006.072.015.18.073.367.12.56.12.193 0 .38-.047.56-.12.023-.009.05-.004.072-.015l5.535-2.487 5.534 2.487a1.538 1.538 0 0 0 1.47-.111c.439-.285.704-.772.704-1.295V10.48a1.54 1.54 0 0 0-.91-1.405Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.b6afeeb17ab47ffc9ff72ae2a857bb66.svg";
export { ForwardRef as ReactComponent };